// Totals, map cards and modal ranges of the Overview
module.exports = {
  ranges: {
    today: {chip: "Today", text: "today"},
    yesterday: {chip: "Yesterday", text: "yesterday"},
    last7: {chip: "7 days", text: "in 7 days"},
    last30: {chip: "30 days", text: "in 30 days"},
    last90: {chip: "90 days", text: "in 90 days"},
    year: {chip: "1 year", text: "in 1 year"},
  },
  totals: {
    open: "See details",
    modalSubtitle: "Each bar has the same length as the selected period.",
    users: {
      label: "Total users",
      noun: "new users",
      hint: "Everyone registered, not only the active ones",
      modalTitle: "New users: this period vs. previous ones",
      info: "Accounts created since the beginning.\nSource: Firebase (sign-up counters).",
    },
    voxpoints: {
      label: "Total VoxPoints",
      noun: "new VoxPoints",
      hint: "All registered VoxPoints",
      modalTitle: "New VoxPoints: this period vs. previous ones",
      info: "VoxPoints created since the beginning, active or not.\nSource: Firebase (VoxPoints).",
    },
    events: {
      label: "Total events",
      noun: "new events",
      hint: "Every event held to date",
      modalTitle: "New events: this period vs. previous ones",
      info: "Events created since the beginning, deleted ones included.\nSource: Firebase (event counters).",
    },
  },
  mapCards: {
    stats: {continents: "Continents", countries: "Countries", cities: "Cities"},
    events: {title: "Events map", total: "Total events on the map", tabs: {total: "Total", active: "Active"}},
    users: {title: "Users map", total: "Total users on the map", tabs: {total: "Total"}},
    voxpoints: {title: "VoxPoints map", total: "Total VoxPoints on the map", tabs: {total: "Total"}},
  },
};
